// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__huC-2","title":"styles_title__1Xduq"};